import React, {
    Fragment,
    FunctionComponent,
    useEffect,
    useState,
} from 'react';
import {
    Col,
    Row as BSRow,
    FormCheck,
    Table,
    Dropdown,
    DropdownButton,
} from 'react-bootstrap';
import {
    Row,
    downloadSheets,
    generateSheet,
} from '../../../utils';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { I18N } from '../../../i18n-raw';
import { AuthedLayout } from '../../../components';
import { useCheckGrade } from '../../../hook';
import {
    UnpivotedBloodCheck,
    UserInfo,
} from '../../../model';
import apis from '../../../apis';
import { toast } from 'react-toastify';

const borderStyle = {
    color: { rgb: '000000' },
    style: 'thin',
} as const;

const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const BorderStyle = {
    bottom: borderStyle,
    top: borderStyle,
    left: borderStyle,
    right: borderStyle,
};

const mapState = (app: ApplicationState) => ({
    ...app.auth,
});

const mapDispatch = ErrorDispatches;

const connector = connect(
    mapState,
    mapDispatch
);

type Props =
    ConnectedProps<typeof connector>;

const checkXRayStastic: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const {
        currentSemester = '',
        semesters = {},
    } = user || {};

    const [currentSem] =
        useState(currentSemester);

    const {
        year = -1,
    } = semesters[currentSem];

    const [radioAction, setRadioAction] =
        useState<boolean>(true);

    const {
        selectedYearGrade,
        element: selectgradeElement,
    } = useCheckGrade({
        year,
        isNowGrade: radioAction,
    });

    const [students, setStudents] =
        useState<UnpivotedBloodCheck[]>([]);

    const [userinfo, setUser] =
        useState<UserInfo>();

    const handleRadioChange = (
        isNowGrade: boolean
    ) => {
        setRadioAction(isNowGrade);
    };

    useEffect(() => {
        if (selectedYearGrade) {
            toast
                .promise(
                    apis
                        .getXRayStatistic(
                            selectedYearGrade.year,
                            selectedYearGrade.grade
                        )
                        .then((r) => {
                            setStudents(r);
                        }),
                    {
                        pending:
                            '資料載入中......',
                        success:
                            '資料載入成功！',
                        error:
                            '資料載入失敗！請查看錯誤資訊。',
                    }
                )
                .catch(
                    catchErrorForModal
                );

            apis
                .getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(
                    catchErrorForModal
                );
        }
    }, [
        selectedYearGrade?.year,
        selectedYearGrade?.grade,
    ]);

    const contentRows: Row[] =
        students.flatMap((gs) => {
            return bloodchecktoRow(
                gs.items,
                gs.m0,
                gs.m1,
                gs.m2,
                gs.m3,
                gs.f0,
                gs.f1,
                gs.f2,
                gs.f3
            );
        });

    const title =
        `${user.schools[user.currentSchool].name}` +
        `${selectedYearGrade?.year ?? ''}學年` +
        `${selectedYearGrade?.grade ?? ''}年級` +
        `X光檢查統計表`;

    const content: Row[] = [
        {
            cells: [
                {
                    value: title,
                    merge: {
                        column: 16,
                    },
                },
            ],
        },
        {
            cells: [
                {
                    value:
                        '檢驗項目(中文)',
                    merge: {
                        column: 1,
                        row: 2,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '受檢人數',
                    merge: {
                        column: 2,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        '異常(陽性)人數',
                    merge: {
                        column: 3,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        '異常(陽性)%',
                    merge: {
                        column: 3,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        '複檢正常(複檢陰性)',
                    merge: {
                        column: 2,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        '複檢異常(複檢陽性)',
                    merge: {
                        column: 2,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        '未就醫(陽性)',
                    merge: {
                        column: 2,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '就醫率',
                    merge: {
                        column: 1,
                        row: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
            ],
        },
        {
            cells: [
                {
                    value: '男生',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '女生',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '男生',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '女生',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '合計',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '男生%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '女生%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '合計%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '人數',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '人數',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '人數',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value: '%',
                    merge: {
                        column: 1,
                    },
                    style: {
                        border:
                            BorderStyle,
                    },
                },
            ],
        },
        ...contentRows,
    ];

    const handleExcelDownload = () => {
        const workSheet =
            generateSheet(
                [
                    ...content,
                    {
                        cells: [
                            {
                                value:
                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                style: {
                                    alignment: {
                                        horizontal:
                                            'left',
                                    },
                                },
                            },
                        ],
                    },
                ],
                {
                    alignment:
                        cellAlignStyle,
                }
            );

        downloadSheets(
            title,
            userinfo?.exportFileType,
            {
                sheet: workSheet,
                name: 'st',
            }
        );
    };

    const handlePrint = () => {
        const printWindow =
            window.open(
                '',
                '_blank',
                'width=1500,height=900'
            );

        if (!printWindow) {
            alert(
                '瀏覽器阻擋了列印視窗，請允許彈出式視窗。'
            );
            return;
        }

        const escapeHtml = (
            value: unknown
        ): string => {
            return String(
                value ?? ''
            )
                .replace(
                    /&/g,
                    '&amp;'
                )
                .replace(
                    /</g,
                    '&lt;'
                )
                .replace(
                    />/g,
                    '&gt;'
                )
                .replace(
                    /"/g,
                    '&quot;'
                )
                .replace(
                    /'/g,
                    '&#039;'
                );
        };

        const tableRows =
            content
                .map((row) => {
                    const cells =
                        row.cells
                            .map(
                                (
                                    cell
                                ) => {
                                    if (
                                        cell.value ===
                                        undefined
                                    ) {
                                        return '';
                                    }

                                    const colSpan =
                                        cell.merge
                                            ?.column
                                            ? ` colspan="${cell.merge.column}"`
                                            : '';

                                    const rowSpan =
                                        cell.merge
                                            ?.row
                                            ? ` rowspan="${cell.merge.row}"`
                                            : '';

                                    return `
                                        <td${colSpan}${rowSpan}>
                                            ${escapeHtml(
                                        cell.value
                                    )}
                                        </td>
                                    `;
                                }
                            )
                            .join('');

                    return `
                        <tr>
                            ${cells}
                        </tr>
                    `;
                })
                .join('');

        printWindow.document.open();

        printWindow.document.write(`
            <!DOCTYPE html>
            <html lang="zh-Hant">
            <head>
                <meta charset="UTF-8" />

                <title>
                    ${escapeHtml(title)}
                </title>

                <style>
                    * {
                        box-sizing: border-box;
                    }

                    html,
                    body {
                        margin: 0;
                        padding: 0;

                        font-family:
                            "Microsoft JhengHei",
                            "Noto Sans TC",
                            Arial,
                            sans-serif;

                        color: #000;
                    }

                    .print-page {
                        min-height: 190mm;

                        display: flex;
                        flex-direction: column;
                    }

                    table {
                        width: 100%;

                        border-collapse:
                            collapse;

                        table-layout: fixed;
                    }

                    td {
                        border:
                            1px solid #000;

                        padding: 4px 2px;

                        text-align: center;
                        vertical-align: middle;

                        font-size: 8px;

                        word-break:
                            break-word;
                    }

                    tr:first-child td {
                        font-size: 15px;
                        font-weight: bold;
                        padding: 8px;
                    }

                    tr:nth-child(2) td,
                    tr:nth-child(3) td {
                        font-weight: bold;
                    }

                    .footer {
                        margin-top: auto;

                        width: 100%;

                        padding-top: 18px;

                        display: flex;

                        justify-content:
                            space-between;

                        font-size: 10px;
                    }

                    @page {
                        size: A4 landscape;
                        margin: 6mm;
                    }

                    @media print {
                        body {
                            padding: 0;
                        }

                        tr {
                            page-break-inside:
                                avoid;

                            break-inside:
                                avoid;
                        }
                    }
                </style>
            </head>

            <body>
                <div class="print-page">

                    <table>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>

                    <div class="footer">
                        <span>
                            承辦人:
                        </span>

                        <span>
                            組長:
                        </span>

                        <span>
                            主任:
                        </span>

                        <span>
                            校長:
                        </span>
                    </div>

                </div>

                <script>
                    window.onload =
                        function () {
                            window.focus();

                            setTimeout(
                                function () {
                                    window.print();
                                },
                                300
                            );
                        };

                    window.onafterprint =
                        function () {
                            window.close();
                        };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <Col
                    className="d-flex mr-3"
                    xs={3}
                >
                    <FormCheck
                        className="mr-2"
                        value="在學"
                        type="radio"
                        label="在學"
                        name="list-action"
                        checked={
                            radioAction ===
                            true
                        }
                        onChange={() =>
                            handleRadioChange(
                                true
                            )
                        }
                    />

                    <FormCheck
                        className="mr-2"
                        value="歷屆年級"
                        type="radio"
                        label="歷屆年級"
                        name="list-action"
                        checked={
                            radioAction ===
                            false
                        }
                        onChange={() =>
                            handleRadioChange(
                                false
                            )
                        }
                    />
                </Col>

                <Col
                    xs={3}
                    className="mr-3"
                >
                    {selectgradeElement}
                </Col>

                <div>
                    <DropdownButton
                        id="check-xray-static-export"
                        title="匯出"
                        variant="success"
                        disabled={
                            !students.length
                        }
                    >
                        <Dropdown.Item
                            onClick={
                                handleExcelDownload
                            }
                        >
                            Excel 下載
                        </Dropdown.Item>

                        <Dropdown.Item
                            onClick={
                                handlePrint
                            }
                        >
                            列印
                        </Dropdown.Item>
                    </DropdownButton>
                </div>
            </BSRow>

            <hr />

            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{
                        tableLayout:
                            'fixed',
                    }}
                >
                    <tbody>
                        {content.map(
                            (
                                r,
                                i
                            ) => {
                                const cells =
                                    r.cells.map(
                                        (
                                            c,
                                            j
                                        ) =>
                                            c.value !==
                                                undefined ? (
                                                <td
                                                    colSpan={
                                                        c
                                                            .merge
                                                            ?.column
                                                    }
                                                    rowSpan={
                                                        c
                                                            .merge
                                                            ?.row
                                                    }
                                                    key={`${i}-${j}`}
                                                >
                                                    {
                                                        c.value
                                                    }
                                                </td>
                                            ) : (
                                                <Fragment
                                                    key={`${i}-${j}`}
                                                />
                                            )
                                    );

                                return (
                                    <tr
                                        key={
                                            i
                                        }
                                    >
                                        {
                                            cells
                                        }
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );
};

function bloodchecktoRow(
    items: string,
    m0: number,
    m1: number,
    m2: number,
    m3: number,
    f0: number,
    f1: number,
    f2: number,
    f3: number
): Row[] {
    const maleTotal =
        (m0 ?? 0) +
        (m1 ?? 0) +
        (m2 ?? 0) +
        (m3 ?? 0);

    const femaleTotal =
        (f0 ?? 0) +
        (f1 ?? 0) +
        (f2 ?? 0) +
        (f3 ?? 0);

    const total =
        maleTotal +
        femaleTotal;

    const malePos =
        (m1 ?? 0) +
        (m2 ?? 0) +
        (m3 ?? 0);

    const femalePos =
        (f1 ?? 0) +
        (f2 ?? 0) +
        (f3 ?? 0);

    const posTotal =
        malePos +
        femalePos;

    const recheckNormal =
        (m2 ?? 0) +
        (f2 ?? 0);

    const recheckAbnormal =
        (m3 ?? 0) +
        (f3 ?? 0);

    const notVisited =
        posTotal -
        recheckNormal -
        recheckAbnormal;

    const visited =
        recheckNormal +
        recheckAbnormal;

    return [
        {
            cells: [
                {
                    value:
                        items ===
                            'X光其他'
                            ? items
                            : I18N.XRay[
                            items
                            ],
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        maleTotal,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        femaleTotal,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        malePos,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        femalePos,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        percent(
                            malePos,
                            maleTotal
                        ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        percent(
                            femalePos,
                            femaleTotal
                        ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        percent(
                            posTotal,
                            total
                        ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? 0
                            : recheckNormal,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? ''
                            : percent(
                                recheckNormal,
                                posTotal
                            ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? 0
                            : recheckAbnormal,
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? ''
                            : percent(
                                recheckAbnormal,
                                posTotal
                            ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? 0
                            : Math.max(
                                0,
                                notVisited
                            ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? ''
                            : percent(
                                Math.max(
                                    0,
                                    notVisited
                                ),
                                posTotal
                            ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
                {
                    value:
                        posTotal ===
                            0
                            ? ''
                            : percent(
                                visited,
                                posTotal
                            ),
                    style: {
                        border:
                            BorderStyle,
                    },
                },
            ],
        },
    ];
}

function percent(
    value: number,
    denominator: number
): string {
    if (!denominator) {
        return '0.00%';
    }

    return (
        (
            (
                value /
                denominator
            ) *
            100
        ).toFixed(2) +
        '%'
    );
}

export const CheckXRayStastic =
    connector(checkXRayStastic);